import React from "react";
import { push } from "connected-react-router";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import NoImage from "../../assets/img/src/no_image.png";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "110px",
    margin: "0px 2px 25px 2px ",
  },
  content: {},
  media: {
    objectFit: "cover",
    paddingTop: "100%",
  },
  price: {
    color: "rgb(100, 100, 100)",
    fontSize: 12,
    letterSpacing: 0.7,
  },
  opusName: {
    fontWeight: "bold",
    fontSize: 13,
    color: "rgb(100, 100, 100)",
    letterSpacing: 0.7,
  },
}));

const OpusCard = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const images = props.images.length > 0 ? props.images : [NoImage];
  const price = props.price;

  return (
    <div className="hover1" onClick={() => dispatch(push("/opus/edit/" + props.id))}>
      <Card className={classes.root}>
        <CardMedia className={classes.media} image={images[0].path} title={props.name} />
        <CardContent className={classes.content}>
          <div>
            <Typography className={classes.opusName} component="p">
              {props.name}
            </Typography>
            <div className="spacer-box--ss" />
            <Typography className={classes.price} component="p">
              ¥{price.toLocaleString()}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OpusCard;
